import { IBooking } from "../api/bookings/IBookings";
import {
  ICargoUpdateRequestDto,
  IHazardousUpdateRequestDto,
  IUpdateBooking,
} from "../api/bookings/IUpdate";

export function mapBookingToUpdateBooking(booking: IBooking): IUpdateBooking {
  const hazardousUpdateRequestDtos: IHazardousUpdateRequestDto[] =
    booking.hazardous.map((h) => ({
      id: h.id,
      unNumber: h.unNumber ? h.unNumber : "",
      adrClass: h.adrClass,
      adrPackingGroup: h.adrPackingGroup ? h.adrPackingGroup : "",
      adrNumberOfPackages: h.adrNumberOfPackages,
      adrNetWeight: h.adrNetWeight,
      adrGrossWeight: h.adrGrossWeight,
    }));

  const cargoUpdateRequestDtos: ICargoUpdateRequestDto[] = booking.cargo.map(
    (c) => ({
      id: c.id,
      numberOfPackages: c.numberOfPackages,
      goodsDescription: c.goodsDescription,
      packageType: c.packageType,
      netWeight: c.netWeight,
      customsDocumentType: c.customsDocumentType,
      exportMRNNumber: c.exportMRNNumber,
    })
  );

  return {
    status: booking.status ? booking.status : "",
    customerCode: booking.customerCode,
    tareWeight: booking.tareWeight,
    netWeight: booking.netWeight,
    unitType: booking.unitType ? booking.unitType : "",
    plateNumber: booking.plateNumber,
    isCranable: booking.isCranable,
    iluCode: booking.iluCode ? booking.iluCode : "",
    customsDocumentType: booking.customsDocumentType
      ? booking.customsDocumentType
      : "",
    hazardousUpdateRequestDtos,
    cargoUpdateRequestDtos,
  };
}
